import {
  AgentSourceId,
  defaultAgentSourceIncludes,
} from '../types/AgentSource';

/** Renderer-side mirror of main-process include flags for the streaming bridge. */
let current = defaultAgentSourceIncludes();

export const getAgentSourceIncludes = (): Record<AgentSourceId, boolean> => ({
  ...current,
});

export const setAgentSourceIncludesState = (
  next: Record<AgentSourceId, boolean>,
): void => {
  current = { ...next };
};

export const isAgentSourceIncluded = (id: AgentSourceId): boolean =>
  current[id] ?? true;
